import {
  isInArticleAdUnit,
  isStandardBannersAdUnit
} from '../../../../../common/js/adUnit';
import { InArticleVideoSizesHandlerStrategy } from './in-article-video-sizes-handler-strategy';
import { VideoSizesHandlerStrategy } from './video-sizes-handler-strategy';
import { VideoStore } from '../../../../../common/js/stores/video.store';
import { AnalyticsStore } from '../../../../../common/js/stores/analytics.store';
import { StandardBannersVideoSizesHandlerStrategy } from './standard-banners-video-sizes-handler-strategy';

export function getVideoSizesHandlerStrategy(
  videoStore: VideoStore,
  analyticsStore: AnalyticsStore
):
  | VideoSizesHandlerStrategy
  | InArticleVideoSizesHandlerStrategy
  | StandardBannersVideoSizesHandlerStrategy {
  if (isInArticleAdUnit(videoStore.adContext.adUnitType)) {
    return new InArticleVideoSizesHandlerStrategy(videoStore, analyticsStore);
  }

  if (isStandardBannersAdUnit(videoStore.adContext.adUnitType)) {
    return new StandardBannersVideoSizesHandlerStrategy(
      videoStore,
      analyticsStore
    );
  }

  return new VideoSizesHandlerStrategy(analyticsStore);
}
